import { EntitySnapshot } from "api/generated/model";

interface LatestEntitySnapshotOption {
    entityId: string;
    name: string;
}

interface RowWithEntitySnapshot {
    entity: EntitySnapshot | null;
    /* Control result creation timestamp, that is */
    created: string;
}

/**
 * Build array of possible Entity options
 * Keyed by id, so that it survives a rename
 * Only the latest snapshot name of each entity is included
 */
export function buildLatestEntitySnapshotOptions(
    rows: { original: RowWithEntitySnapshot }[]
): LatestEntitySnapshotOption[] {
    const latestSnapshots = new Map<
        string,
        { created: number; name: string }
    >();
    for (const { original } of rows) {
        const { entity, created } = original;
        if (entity) {
            const entityId = entity.id.toString();
            const createdTime = new Date(created).getTime();
            const existing = latestSnapshots.get(entityId);
            if (!existing || createdTime > existing.created) {
                // Lets store the latest snapshot for this entity
                latestSnapshots.set(entityId, {
                    created: createdTime,
                    name: entity.name,
                });
            }
        }
    }
    return latestSnapshots
        .entries()
        .map(([entityId, { name }]) => ({ entityId, name }))
        .toArray();
}
